import { render } from "./AddNumberDialog.vue?vue&type=template&id=5d226578&scoped=true"
import script from "./AddNumberDialog.vue?vue&type=script&lang=js"
export * from "./AddNumberDialog.vue?vue&type=script&lang=js"

import "./AddNumberDialog.vue?vue&type=style&index=0&id=5d226578&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d226578"]])

export default __exports__